import * as React from 'react';
export const paypaySvg = React.forwardRef(function paypaySvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F03',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M0 9.647c4.284-.436 8.278-.425 11.782-.086L6.284 32h1.937l1.47-6.154c9.811-.757 15.85-3.054 17.161-9.04C28.305 10.151 19.035 3.49 0 4.03v5.616Zm13.526.12c7.96 1.085 12.933 3.961 12.175 7.067-.815 3.34-8.392 5.367-15.064 5.046l2.889-12.113Z',
      fill: '#fff',
    }),
  );
});
paypaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var paypay = {
  category: 'brand',
  colorable: false,
  name: 'paypay',
  svg: paypaySvg,
};
